export default {"PACKAGE_VERSION": "2.1.68989.0 (694f27cf)","UI_THEME": "polaris"}